module.exports = __webpack_public_path__ + "img/1-1.226c61d1.jpg";